import { FC } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';
import API from 'core/Api';
import IResponseData from 'types/api';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity } from 'utils/helpers/client';
import MainLayout from 'components/main-layout/MainLayout';
import EditForm from './EditForm';
import { IElement, IDropdowns } from '../types';

interface IProps {
  elementsEntityName: string;
  elementsEndpoint: string;
}

const Edit: FC<IProps> = ({ elementsEntityName, elementsEndpoint }) => {
  const { id } = useParams<{ id: string | undefined }>();
  const { client } = useActiveClientContext();
  const { isLoading, error, data } = useQuery<IElement, Error>(
    [buildClientEntity(elementsEntityName, client), { id }],
    (): Promise<IElement> =>
      API.get<IResponseData<IElement>>(`${elementsEndpoint}?id=${id}`).then(res => res.data?.items[0])
  );

  const { isLoading: isLoadingDropdowns, data: dropdowns } = useQuery<IDropdowns, Error>(
    [buildClientEntity('client-elements-dropdowns', client)],
    (): Promise<IDropdowns> => {
      return API.get(`${elementsEndpoint}/dropdown-options`).then(
        res =>
          res.data?.bg && {
            ...res.data.bg,
          }
      );
    }
  );
  const identifierOptions = [...(dropdowns?.paid_sub_types || []), ...(dropdowns?.work_trip_accommodation_types || [])];

  return (
    <MainLayout
      title="Редактиране на елемент"
      isLoading={isLoading && isLoadingDropdowns}
      error={error}
    >
      {data && (
        <EditForm
          elementsEntityName={elementsEntityName}
          elementsEndpoint={elementsEndpoint}
          element={data}
          identifierOptions={identifierOptions}
        />
      )}
    </MainLayout>
  );
};

export default Edit;
